export function validEmail(email: string) {
    return String(email)
        .toLowerCase()
        .match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);
}

export const isValidZip = (value: string) => {
    return /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
};
